import { CalloutBlock } from "@bezoned/shared/components/callout-block.jsx";
import { Body2, Button, Title3 } from "@fluentui/react-components";
import { AddSquare20Regular } from "@fluentui/react-icons";

// ! There is another very similar component used in the table Context Menu. That one is used as Modal. Due to the
// ! difference between the two, I've decided to keep them separate.
// ! However keep in mind, that any logic or copy change needs to be reflected there as well.
// ! @see AddNewBoardModal

interface AddNewBoardInstructionsProps {
  onNext: () => void;
  onClose: () => void;
}

export const AddNewBoardInstructions = ({
  onNext,
  onClose,
}: AddNewBoardInstructionsProps) => (
  <div className="flex h-screen w-full flex-col gap-4 overflow-y-auto p-4">
    <div>
      <Title3>Add Notes, Whiteboard, Planner, or another item ...</Title3>
    </div>
    <div>
      <Body2>To add tools or boards to the Table menu, do the following:</Body2>

      <ul className="list-outside list-decimal space-y-1 py-4 pl-8">
        <li>
          <Body2>
            Click on the <strong>Next</strong> button.
          </Body2>
        </li>
        <li>
          <Body2>
            To add more or other items, click on the <AddSquare20Regular />{" "}
            button.
          </Body2>
        </li>
      </ul>

      <CalloutBlock compact variant="note">
        <strong>Note: </strong> it may take a moment for the new board or item
        to show after adding it.
      </CalloutBlock>
    </div>

    <div className="w-full">
      <img
        alt="Arrow pointing to the Tab menu of a channel"
        height={1622}
        src="/images/add-table-menu-board.png"
        width={2355}
      />
    </div>

    <div className="flex flex-row justify-between">
      <Button
        appearance="transparent"
        className="text-bzd-gray-200"
        onClick={onClose}
      >
        Cancel
      </Button>
      <Button appearance="primary" onClick={onNext}>
        Next
      </Button>
    </div>
  </div>
);
